<div class="card sales-1 overflow-hidden rounded-10 shadow">
  <div class="card-body" style="min-height: 133px !important" *ngIf="isLoaded">
    <app-loading-dash [size]="'card-top'" />
  </div>
  <div class="card-body" style="min-height: 133px !important" *ngIf="!isLoaded">
    <span class="bg-primary-transparent icon-service icon-blue float-end"
      ><i class="fe fe-trending-up"></i>
    </span>
    <h6 class="mb-3">{{ 'common.generalBalance' | translate }}</h6>
    <h4 class="mb-1">
      <span class="number-font"
        >
        <span class="counter">{{
          generalAmount
            | formatCurrency
        }}</span></span
      >
    </h4>
    <p class="mb-2">
      <span class="text-danger fs-13 me-2"
        >{{ 'common.blockedAmount' | translate }}:
        {{
          blockedAmount
            | formatCurrency
        }}</span
      >
    </p>
  </div>
</div>
